import * as React from "react";
import { ChangeEvent, useEffect, useState } from "react";
import AsyncAction from "../AsyncAction";
import TextInput from "../commons/components/form/input/TextInput";
import { MessageLevel } from "../commons/model/form/Field";
import "./SettingPrimaryColor.scss";

export interface SettingPrimaryColorProps {
  primaryColor: string;
  defaultColor: string;
  onColorChange: (colorCode: string) => void;
}

const SettingPrimaryColor = (props: SettingPrimaryColorProps) => {
  const [currentColor, setCurrentColor] = useState(props.primaryColor);

  const changeColor = (newColor: string) => {
    props.onColorChange(newColor);
  };

  useEffect(() => {
    changeColor(currentColor);
  }, [currentColor]);

  const handleColorChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedColor = event.target.value;
    changeColor(selectedColor);
  };

  function colorValidator() {
    const colorPattern = /^#[0-9a-fA-F]{6}$/i;
    const validator = (value) => value.match(colorPattern) === null;
    validator.messageLevel = MessageLevel.ERROR;
    validator.errorMessage = i18n["Form.Error.InvalidColorCode"];
    return validator;
  }

  return (
    <div className="setting-grid">
      <div className="item-highlight">{i18n["Page.Settings.Color.Primary.Select"]}</div>
      <div className="react-form inline">
        <div className="input-group h-flex align-center with-margins">
          <input
            id={"primary-color-preview"}
            type="color"
            value={props.primaryColor}
            onChange={handleColorChange}
          />
          <TextInput
            additionalClass={"primary-color-input"}
            name={"primary-color-input"}
            validators={[colorValidator()]}
            initialValue={currentColor}
            onChange={(inputState) => setCurrentColor(inputState.value)}
            placeholder={"#000000"}
            maxLength={7}
          />
          {props.primaryColor !== props.defaultColor && (
            <AsyncAction
              buttonId={"restore-default-color-btn"}
              buttonLabel={i18n["Page.Settings.Customisation.Restore.Default"]}
              promise={() => {
                changeColor(props.defaultColor);
                return Promise.resolve();
              }}
              buttonType="button-secondary small"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingPrimaryColor;
